"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var uniq_1 = __importDefault(require("lodash/uniq"));
var providers_1 = require("../../providers");
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var models_1 = require("../models");
var helpers_1 = require("../helpers");
var constants_1 = require("../constants");
var services_1 = require("../services");
var student_item_performance_serializer_1 = require("./serializers/student-item-performance.serializer");
var AnalyticsService = /** @class */ (function (_super) {
    __extends(AnalyticsService, _super);
    function AnalyticsService(options, itemPerformanceClient, assessmentPerformanceClient, assigneePerformanceClient, userService, studentPerformanceSerializer) {
        var _this = _super.call(this, options) || this;
        _this.itemPerformanceClient = itemPerformanceClient;
        _this.assessmentPerformanceClient = assessmentPerformanceClient;
        _this.assigneePerformanceClient = assigneePerformanceClient;
        _this.userService = userService;
        _this.studentPerformanceSerializer = studentPerformanceSerializer;
        return _this;
    }
    AnalyticsService.newInstance = function (options) {
        var clientOptions = {
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        };
        var retryOptions = options.retryOptionsOnNonAuthorized;
        return new AnalyticsService(options, insync_assess_sdk_1.ItemPerformanceClient.newInstance(clientOptions, retryOptions), insync_assess_sdk_1.AssessmentPerformanceClient.newInstance(clientOptions, retryOptions), insync_assess_sdk_1.AssigneePerformanceClient.newInstance(clientOptions, retryOptions), services_1.UserService.newInstance(options), new student_item_performance_serializer_1.StudentItemPerformanceSerializer());
    };
    /**
     * Retrieves the performance items by assessments, items are sorted by percentage, descending.
     * @param assessment          - assessment data
     * @param bands               - performance bands to apply to the items
     * @param {number} limit      - indicates the number of assessments to display
     */
    AnalyticsService.prototype.getItemsPerformanceByAssessment = function (assessment, bands, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var id, items, itemLabels, coreItems, itemsPerformance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = assessment.id, items = assessment.assessmentTemplate.items;
                        itemLabels = (0, helpers_1.getItemLabels)(items);
                        items.forEach(function (item, index) {
                            item.label = itemLabels[index];
                        });
                        coreItems = models_1.AssessmentTemplate.findCoreItems([assessment.assessmentTemplate]);
                        return [4 /*yield*/, this.itemPerformanceClient.findByAssessment(id, this.getDefaultHeaders())];
                    case 1:
                        itemsPerformance = _a.sent();
                        return [2 /*return*/, this.getLowestPerformanceItems(coreItems, itemsPerformance, bands, limit)];
                }
            });
        });
    };
    /**
     * Retrieves the performance items by class and assignee
     * @param {Class[]}               aClass              - the class to look for
     * @param {AssessmentTemplate[]}  templates           - the assessment template involved in this report
     * @param {string}                assigneeId          - the assignee to filter the data by
     * @param {PerformanceBand[]}     bands               - performance bands to apply to the items
     * @param {number}                limit               - indicates the number of assessments to display
     */
    AnalyticsService.prototype.getOverallStandardPerformanceByClassAndAssignee = function (aClass, templates, assigneeId, bands, standardsList, standardHierarchyLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var templatesIds, itemPerformanceDtos, items, itemsPerformance, standardsPerformance, _a, maxScore, score, overallPercentage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        templatesIds = templates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.itemPerformanceClient.findByContextAndAssignee([aClass.id], assigneeId, (0, uniq_1.default)(templatesIds), this.getDefaultHeaders())];
                    case 1:
                        itemPerformanceDtos = _b.sent();
                        items = models_1.AssessmentTemplate.findCoreItems(templates);
                        itemsPerformance = this.getItemsPerformance(itemPerformanceDtos, items, bands);
                        standardsPerformance = this.buildStandardsPerformance(itemsPerformance, bands, standardsList, standardHierarchyLevel);
                        _a = models_1.ItemPerformance.calculatePerformance(itemsPerformance), maxScore = _a.maxScore, score = _a.score;
                        overallPercentage = this.calculatePercentage(score, maxScore);
                        return [2 /*return*/, new models_1.OverallStandardPerformance({
                                classes: [aClass],
                                overallPercentage: overallPercentage,
                                overallPerformanceBand: (0, helpers_1.findPerformanceBand)(overallPercentage, bands),
                                standardsPerformance: standardsPerformance,
                            })];
                }
            });
        });
    };
    /**
     * Returns the standard performance for a set of items performance
     * @param assessmentTemplates
     * @param itemsPerformance
     * @param bands
     */
    AnalyticsService.prototype.buildStandardsPerformance = function (itemsPerformance, bands, standardsList, standardHierarchyLevel) {
        var _this = this;
        if (standardHierarchyLevel === void 0) { standardHierarchyLevel = constants_1.StandardHierarchyLevel.Standard; }
        return standardsList.map(function (standard) {
            var itemsPerformanceByStandard = models_1.ItemPerformance.itemsPerformanceByStandardFromMicroApp(standard, standardHierarchyLevel, itemsPerformance);
            var _a = models_1.ItemPerformance.calculatePerformance(itemsPerformanceByStandard), maxScore = _a.maxScore, score = _a.score;
            var percentage = _this.calculatePercentage(score, maxScore);
            var band = (0, helpers_1.findPerformanceBand)(percentage, bands);
            return new models_1.StandardPerformance({
                standard: standard,
                totalItems: itemsPerformanceByStandard.length,
                percentage: percentage,
                maxScore: maxScore,
                score: score,
                band: band,
                attempted: itemsPerformanceByStandard.length > 0,
            });
        });
    };
    /**
     * Retrieves the performance items by context and templates, items are sorted by percentage, descending.
     * @param classes                - classes to filter
     * @param assessmentTemplate     - assessment template data
     * @param bands                  - performance bands to apply to the items
     * @param {number} limit         - indicates the number of assessments to display
     * @param filter                 - indicates if it should filter results per assessment
     */
    AnalyticsService.prototype.getItemsPerformanceByContextAndTemplate = function (classes, assessmentTemplate, bands, limit, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var classIds, itemsPerformance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        classIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.itemPerformanceClient.findByContextAndTemplate(classIds, assessmentTemplate.id, filter, this.getDefaultHeaders())];
                    case 1:
                        itemsPerformance = _a.sent();
                        return [2 /*return*/, bands
                                ? this.getLowestPerformanceItems(assessmentTemplate.items, itemsPerformance, bands, limit)
                                : this.getItemsPerformance(itemsPerformance, assessmentTemplate.items).slice(0, limit || assessmentTemplate.items.length)];
                }
            });
        });
    };
    /**
     * Retrieves the performance classes by classes and template
     * @param classes                - classes to process
     * @param assessmentTemplate     - assessment template data
     * @param assigneesPerformance   - assignees performance
     * @param bands                  - performance bands to apply to the items
     * @param type                   - filter item type. e.g:  core, branch
     */
    AnalyticsService.prototype.getClassPerformanceByClassAndTemplate = function (classes, assessmentTemplate, assigneesPerformance, bands, type) {
        return __awaiter(this, void 0, void 0, function () {
            var items, itemsPerformance, overallPercentage, overallScore, overallMaxScore;
            return __generator(this, function (_a) {
                items = type === constants_1.ItemType.Core
                    ? models_1.AssessmentTemplate.findCoreItems([assessmentTemplate])
                    : models_1.AssessmentTemplate.findItems([assessmentTemplate]);
                itemsPerformance = this.getClassItemsPerformance(items, assigneesPerformance, bands);
                overallPercentage = (0, helpers_1.formatPercentage)(this.getAssigneeOverallPercentageAverage(assigneesPerformance));
                overallScore = this.getAssigneeOverallScoreAverage(assigneesPerformance);
                overallMaxScore = this.getAssigneeOverallMaxScoreAverage(assigneesPerformance);
                return [2 /*return*/, new models_1.ClassPerformance({
                        class: classes,
                        overallPercentage: overallPercentage,
                        score: overallScore,
                        maxScore: overallMaxScore,
                        overallPerformanceBand: (0, helpers_1.findPerformanceBand)(overallPercentage, bands),
                        itemsPerformance: itemsPerformance,
                    })];
            });
        });
    };
    /**
     * Retrieves the performance assignees by classes and template
     * @param classes                - classes to show
     * @param assessmentTemplate     - assessment template data
     * @param bands                  - performance bands to apply to the items
     * @param {number} limit         - indicates the number of assessments to display
     * @param type                   - filter item type. e.g:  core, branch
     */
    AnalyticsService.prototype.getAssigneesPerformancesByClassAndTemplate = function (classes, assessmentTemplate, bands, limit, assessment, type, itemStandards) {
        return __awaiter(this, void 0, void 0, function () {
            var classIds, assessmentTemplates, assessmentTemplateIds, filters, assigneesPerformance, usersIds, users, _a, items, itemLabels;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        classIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        assessmentTemplates = Array.isArray(assessmentTemplate)
                            ? assessmentTemplate
                            : [assessmentTemplate];
                        assessmentTemplateIds = assessmentTemplates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        filters = {
                            assessmentId: assessment ? assessment.id : undefined,
                            itemTypes: type === constants_1.ItemType.Core ? [constants_1.ItemType.Core] : undefined,
                        };
                        return [4 /*yield*/, this.assigneePerformanceClient.findByContextAndTemplate(classIds, (0, uniq_1.default)(assessmentTemplateIds), constants_1.AssigneePerformanceGroupBy.Item, filters, this.getDefaultHeaders())];
                    case 1:
                        assigneesPerformance = _b.sent();
                        usersIds = assigneesPerformance.map(function (performance) { return performance.assigneeId; });
                        if (!!(0, isEmpty_1.default)(usersIds)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userService.findByIds(usersIds, true, true)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        users = _a;
                        items = type === constants_1.ItemType.Core
                            ? models_1.AssessmentTemplate.findAllCoreItems(assessmentTemplates)
                            : models_1.AssessmentTemplate.findAllItems(assessmentTemplates);
                        itemLabels = (0, helpers_1.getItemLabels)(items);
                        items.forEach(function (item, index) {
                            item.label = itemLabels[index];
                            if (itemStandards) {
                                _this.mergeStandardsByHierarchy(itemStandards, item);
                            }
                        });
                        return [2 /*return*/, this.getAssigneesPerformance(users, (0, uniqBy_1.default)(items, 'externalId'), assigneesPerformance, bands, limit)];
                }
            });
        });
    };
    /**
     * It returns AssigneePerformance data sorted by percentage, ascending. It also matches
     * the data with the corresponding item and band.
     * @param items
     * @param users
     * @param assigneesPerformance
     * @param bands
     * @param limit
     */
    AnalyticsService.prototype.getAssigneesPerformance = function (users, items, assigneesPerformance, bands, limit) {
        var _this = this;
        return users
            .map(function (user) {
            var assignee = assigneesPerformance.find(function (a) { return a.assigneeId === user.id; });
            if (assignee) {
                var maxScore = assignee.maxScore, score = assignee.score;
                var percentage = (0, helpers_1.formatPercentage)(_this.calculatePercentage(score, maxScore));
                var itemsPerformance = assignee.itemsPerformance
                    ? assignee.itemsPerformance
                    : [];
                return new models_1.AssigneePerformance({
                    assignee: user,
                    overallPercentage: percentage,
                    overallPerformanceBand: !(0, isUndefined_1.default)(bands)
                        ? (0, helpers_1.findPerformanceBand)(percentage, bands)
                        : undefined,
                    maxScore: maxScore,
                    score: score,
                    itemsPerformance: _this.getItemsPerformance(itemsPerformance, items, bands),
                });
            }
            return new models_1.AssigneePerformance();
        })
            .filter(function (assignee) { return assignee.assignee; })
            .slice(0, limit || users.length);
    };
    /**
     * It returns ItemPerformance data sorted by percentage, ascending. It also matches
     * the data with the corresponding item and band.
     * @param items
     * @param itemsPerformance
     * @param bands
     * @param limit
     */
    AnalyticsService.prototype.getLowestPerformanceItems = function (items, itemsPerformance, bands, limit) {
        return this.getItemsPerformance(itemsPerformance, items, bands)
            .sort(function (a, b) {
            return a.percentage > b.percentage ? 1 : a.percentage === b.percentage ? a.index - b.index : -1;
        })
            .slice(0, limit || items.length);
    };
    /**
     * Retrieves the performance items by assessments, items are sorted by percentage, descending.
     * @param assessments[]        - assessment data
     * @param bands               - performance bands to apply to the items
     */
    AnalyticsService.prototype.getAssessmentsPerformanceBandDistribution = function (assessments, bands) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, assessmentsPerformance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = assessments.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.assessmentPerformanceClient.findByAssessment(ids, constants_1.AssessmentPerformanceGroupBy.Assessment, this.getDefaultHeaders())];
                    case 1:
                        assessmentsPerformance = _a.sent();
                        return [2 /*return*/, this.buildAssessmentsPerformanceBandDistribution(assessments, assessmentsPerformance, bands)];
                }
            });
        });
    };
    /**
     * Builds the information for the assessment performance band distribution report.
     * @param assessments
     * @param assessmentsPerformance
     * @param bands
     */
    AnalyticsService.prototype.buildAssessmentsPerformanceBandDistribution = function (assessments, assessmentsPerformance, bands) {
        var distributionMap = {};
        var _loop_1 = function (assessment) {
            var assessmentDistribution = distributionMap[assessment.id];
            if (!assessmentDistribution) {
                assessmentDistribution = new models_1.AssessmentPerformanceBandDistribution({ assessment: assessment });
            }
            var assessmentPerformance = assessmentsPerformance.find(function (_a) {
                var assessmentId = _a.assessmentId;
                return assessmentId === assessment.id;
            });
            if (assessmentPerformance) {
                this_1.addAssessmentPerformanceBandDistribution(assessmentDistribution, assessmentPerformance, bands);
            }
            distributionMap[assessment.id] = assessmentDistribution;
        };
        var this_1 = this;
        for (var _i = 0, assessments_1 = assessments; _i < assessments_1.length; _i++) {
            var assessment = assessments_1[_i];
            _loop_1(assessment);
        }
        return Object.values(distributionMap);
    };
    AnalyticsService.prototype.addAssessmentPerformanceBandDistribution = function (assessmentDistribution, assessmentPerformance, bands) {
        var _this = this;
        var assigneesPerformance = assessmentPerformance.assigneesPerformance || [];
        var totalAssignees = assigneesPerformance.length;
        bands.forEach(function (band) {
            var bandAssignees = assigneesPerformance.filter(function (_a) {
                var maxScore = _a.maxScore, score = _a.score;
                return band.inRange(_this.calculatePercentage(score, maxScore));
            }).length;
            assessmentDistribution.addPerformanceBandDistribution({
                band: band,
                sample: bandAssignees,
                percentage: totalAssignees ? (bandAssignees / totalAssignees) * 100 : 0,
            });
        });
    };
    /**
     * Retrieves the assessment performance band distribution by classes and assessment template.
     * @param classes
     * @param assessmentTemplate
     * @param bands               - performance bands to apply to the items
     */
    AnalyticsService.prototype.getAssessmentPerformanceBandDistributionByClassAndTemplate = function (classes, assessmentTemplate, bands) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, assessmentsPerformance, assessmentDistribution;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.assessmentPerformanceClient.findByContextAndTemplate(ids, [assessmentTemplate.id], this.getDefaultHeaders())];
                    case 1:
                        assessmentsPerformance = _a.sent();
                        assessmentDistribution = new models_1.AssessmentPerformanceBandDistribution();
                        if (assessmentsPerformance.length) {
                            this.addAssessmentPerformanceBandDistribution(assessmentDistribution, assessmentsPerformance[0], bands);
                        }
                        return [2 /*return*/, assessmentDistribution];
                }
            });
        });
    };
    AnalyticsService.prototype.getItemsPerformance = function (itemsPerformance, items, bands) {
        var _this = this;
        return items.map(function (item, itemIndex) {
            var performance = itemsPerformance.find(function (_a) {
                var itemExternalId = _a.itemExternalId;
                return itemExternalId === item.externalId;
            });
            var _a = performance || {}, _b = _a.maxScore, maxScore = _b === void 0 ? 0 : _b, _c = _a.score, score = _c === void 0 ? 0 : _c;
            var percentage = _this.calculatePercentage(score, maxScore);
            var index = itemIndex + 1;
            var timeSpent = performance && performance.timeSpent;
            var band = bands && (0, helpers_1.findPerformanceBand)(percentage, bands);
            return new models_1.ItemPerformance({
                item: item,
                percentage: percentage,
                maxScore: maxScore,
                score: score,
                index: index,
                band: band,
                timeSpent: timeSpent,
                attempted: !!performance,
            });
        });
    };
    AnalyticsService.prototype.getClassItemsPerformance = function (items, assigneesPerformance, bands) {
        return items.map(function (item, index) {
            var sumItemPercentage = assigneesPerformance.reduce(function (total, assignee) {
                var assigneeItemPerformance = assignee.itemsPerformance.find(function (a) { return a.item.externalId === item.externalId; });
                var itemPercentage = assigneeItemPerformance && assigneeItemPerformance.percentage
                    ? assigneeItemPerformance.percentage
                    : 0;
                return total + itemPercentage;
            }, 0);
            var sumItemScore = assigneesPerformance.reduce(function (total, assignee) {
                var assigneeItemPerformance = assignee.itemsPerformance.find(function (a) { return a.item.externalId === item.externalId; });
                var itemScore = assigneeItemPerformance && assigneeItemPerformance.score
                    ? assigneeItemPerformance.score
                    : 0;
                return total + itemScore;
            }, 0);
            var sumItemMaxScore = assigneesPerformance.reduce(function (total, assignee) {
                var assigneeItemPerformance = assignee.itemsPerformance.find(function (a) { return a.item.externalId === item.externalId; });
                var itemMaxScore = assigneeItemPerformance && assigneeItemPerformance.maxScore
                    ? assigneeItemPerformance.maxScore
                    : 0;
                return total + itemMaxScore;
            }, 0);
            var averagePercentage = sumItemPercentage / assigneesPerformance.length;
            var averageScore = sumItemScore / assigneesPerformance.length;
            var averageMaxScore = sumItemMaxScore / assigneesPerformance.length;
            return new models_1.ItemPerformance({
                item: item,
                band: (0, helpers_1.findPerformanceBand)(averagePercentage, bands),
                percentage: averagePercentage,
                index: index + 1,
                score: averageScore,
                maxScore: averageMaxScore,
            });
        });
    };
    AnalyticsService.prototype.getAssigneeOverallPercentageAverage = function (assigneesPerformance) {
        return (assigneesPerformance.reduce(function (total, assignee) { return total + assignee.overallPercentage; }, 0) /
            assigneesPerformance.length);
    };
    AnalyticsService.prototype.getAssigneeOverallScoreAverage = function (assigneesPerformance) {
        return (assigneesPerformance.reduce(function (total, assignee) { return total + assignee.score; }, 0) /
            assigneesPerformance.length);
    };
    AnalyticsService.prototype.getAssigneeOverallMaxScoreAverage = function (assigneesPerformance) {
        return (assigneesPerformance.reduce(function (total, assignee) { return total + assignee.maxScore; }, 0) /
            assigneesPerformance.length);
    };
    /**
     * Retrieves the assignees standard performance by class and template
     * @param {Class[]}                 classes
     * @param {AssessmentTemplate[]}    assessmentTemplates
     * @param {PerformanceBand[]}       bands
     * @param {StandardType}            standardType
     *
     * @return {AssigneeStandardPerformance[]} standard performance information per assignee
     */
    AnalyticsService.prototype.getAssigneesStandardPerformanceByClassAndTemplate = function (classes, assessmentTemplates, bands, standardHierarchyLevel, standards, itemStandards) {
        return __awaiter(this, void 0, void 0, function () {
            var assigneesPerformance, usersIds, users, _a, assigneesStandardPerformance;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAssigneesPerformancesByClassAndTemplate(classes, assessmentTemplates, bands, undefined, undefined, undefined, itemStandards)];
                    case 1:
                        assigneesPerformance = _b.sent();
                        usersIds = assigneesPerformance.map(function (performance) { return performance.assignee.id; });
                        if (!!(0, isEmpty_1.default)(usersIds)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userService.findByIds(usersIds, true, true)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        users = _a;
                        assigneesStandardPerformance = [];
                        users.forEach(function (user) {
                            var assigneePerformance = assigneesPerformance.find(function (_a) {
                                var assignee = _a.assignee;
                                return assignee.id === user.id;
                            });
                            var assigneeStandardPerformance;
                            if (assigneePerformance) {
                                assigneeStandardPerformance = _this.buildAssigneeStandardPerformance(assigneePerformance, bands, standards, standardHierarchyLevel);
                                assigneesStandardPerformance.push(assigneeStandardPerformance);
                            }
                        });
                        return [2 /*return*/, assigneesStandardPerformance];
                }
            });
        });
    };
    AnalyticsService.prototype.buildAssigneeStandardPerformance = function (assigneePerformance, bands, standards, standardHierarchyLevel) {
        var standardsPerformance = this.buildAssigneeStandardsPerformance(assigneePerformance, standards, bands, standardHierarchyLevel);
        var maxScore = assigneePerformance.maxScore, score = assigneePerformance.score;
        var percentage = this.calculatePercentage(score, maxScore);
        return new models_1.AssigneeStandardPerformance({
            assignee: assigneePerformance.assignee,
            standardsPerformance: standardsPerformance,
            overallPercentage: percentage,
            maxScore: maxScore,
            score: score,
            overallPerformanceBand: (0, helpers_1.findPerformanceBand)(percentage, bands),
        });
    };
    AnalyticsService.prototype.buildAssigneeStandardsPerformance = function (assigneePerformance, standards, bands, standardHierarchyLevel) {
        var _this = this;
        return standards.map(function (standard) {
            var _a = assigneePerformance.performanceByStandard(standard, standardHierarchyLevel), totalItems = _a.totalItems, maxScore = _a.maxScore, score = _a.score, attempted = _a.attempted;
            var percentage = _this.calculatePercentage(score, maxScore);
            var band = (0, helpers_1.findPerformanceBand)(percentage, bands);
            return new models_1.StandardPerformance({
                standard: standard,
                totalItems: totalItems,
                percentage: percentage,
                maxScore: maxScore,
                score: score,
                band: band,
                attempted: attempted,
            });
        });
    };
    /**
     * Retrieves the overall standard performance by classes and template
     * @param {Class[]}                       classes                         - classes to process
     * @param {AssessmentTemplate[]}          assessmentTemplates             - assessment templates
     * @param {AssigneeStandardPerformance[]} assigneesStandardPerformance    - assignees performance
     * @param {PerformanceBand[]}             bands                           - performance bands to apply to the items
     * @param {StandardType}                  standardType                    - standard type to group by
     */
    AnalyticsService.prototype.getOverallStandardPerformanceByClassAndTemplate = function (classes, assigneesStandardPerformance, bands, standards) {
        return __awaiter(this, void 0, void 0, function () {
            var standardsPerformance, _a, maxScore, score, overallPercentage;
            return __generator(this, function (_b) {
                standardsPerformance = this.buildOverallStandardsPerformance(assigneesStandardPerformance, bands, standards);
                _a = models_1.StandardPerformance.calculatePerformance(standardsPerformance), maxScore = _a.maxScore, score = _a.score;
                overallPercentage = this.calculatePercentage(score, maxScore);
                return [2 /*return*/, new models_1.OverallStandardPerformance({
                        classes: classes,
                        overallPercentage: overallPercentage,
                        overallPerformanceBand: (0, helpers_1.findPerformanceBand)(overallPercentage, bands),
                        standardsPerformance: standardsPerformance,
                    })];
            });
        });
    };
    AnalyticsService.prototype.buildOverallStandardsPerformance = function (assigneesStandardPerformance, bands, standards) {
        var _this = this;
        return standards
            .map(function (standard) {
            var _a = models_1.AssigneeStandardPerformance.calculatePerformanceByStandard(standard, assigneesStandardPerformance), maxScore = _a.maxScore, score = _a.score, attempted = _a.attempted;
            var percentage = _this.calculatePercentage(score, maxScore);
            return new models_1.StandardPerformance({
                standard: standard,
                maxScore: maxScore,
                score: score,
                percentage: percentage,
                band: (0, helpers_1.findPerformanceBand)(percentage, bands),
                attempted: attempted,
            });
        })
            .filter(function (performance) { return performance.attempted; });
    };
    /**
     * Returns the percentage based on the provided data, if maxScore is 0 it returns 0
     * @param score
     * @param maxScore
     */
    AnalyticsService.prototype.calculatePercentage = function (score, maxScore) {
        if (score === void 0) { score = 0; }
        if (maxScore === void 0) { maxScore = 0; }
        return maxScore ? (score / maxScore) * 100 : 0;
    };
    /**
     * Retrieve the standard performance band distributions by assignees standard performance and template
     * @param {AssigneeStandardPerformance[]}    assigneesStandardPerformance
     * @param {AssessmentTemplate[]}             assessmentTemplates
     * @param {PerformanceBand[]}                bands
     * @param {StandardType}                     standardType
     * @return {StandardPerformance[]} performance information per standard
     */
    AnalyticsService.prototype.getStandardsPerformanceBandDistribution = function (assigneesStandardPerformance, bands, standards) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, standards.map(function (standard) {
                        var assigneesFiltered = models_1.StandardPerformance.findByStandard(standard, assigneesStandardPerformance);
                        var performanceDistributions = _this.buildPerformanceBandDistributions(bands, assigneesFiltered);
                        return new models_1.StandardPerformanceBandDistribution({
                            standard: standard,
                            totalItems: assigneesFiltered[0] ? assigneesFiltered[0].totalItems : 0,
                            distribution: performanceDistributions,
                        });
                    })];
            });
        });
    };
    AnalyticsService.prototype.buildPerformanceBandDistributions = function (bands, standardsPerformance) {
        var _this = this;
        var attemptedStandardsPerformance = standardsPerformance.filter(function (_a) {
            var attempted = _a.attempted;
            return attempted;
        });
        var totalStandards = attemptedStandardsPerformance.length || 1;
        return bands.map(function (band) {
            var totalInBand = models_1.StandardPerformance.findByPerformanceBand(attemptedStandardsPerformance, band).length || 0;
            return {
                band: band,
                sample: totalInBand,
                percentage: _this.calculatePercentage(totalInBand, totalStandards),
            };
        });
    };
    /**
     * Retrieves the performance band distributions
     * @param {OverallStandardPerformance}       overallStandardPerformance
     * @param {PerformanceBand[]}                bands
     * @return {PerformanceBandDistribution[]} performance band distribution
     */
    AnalyticsService.prototype.getOverallStandardPerformanceBandDistribution = function (overallStandardPerformance, bands) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.buildPerformanceBandDistributions(bands, overallStandardPerformance.standardsPerformance)];
            });
        });
    };
    /**
     * Retrieves the assessment performance by classes and assignee.
     * @param classes
     * @param assessments
     * @param assignee
     * @param bands               - performance bands to apply to the items
     */
    AnalyticsService.prototype.getAssessmentPerformanceByClassAndAssignee = function (classes, assessments, assignee, bands, assessmentTemplates) {
        return __awaiter(this, void 0, void 0, function () {
            var classIds, assessmentTemplateIds, assessmentPerformanceDtos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        classIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        assessmentTemplateIds = assessmentTemplates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.assessmentPerformanceClient.findByContextAndAssignee(classIds, [assignee.id], (0, uniq_1.default)(assessmentTemplateIds), this.getDefaultHeaders())];
                    case 1:
                        assessmentPerformanceDtos = _a.sent();
                        return [2 /*return*/, this.buildAssessmentPerformance(assessments, assessmentPerformanceDtos, bands)];
                }
            });
        });
    };
    /**
     * Retrieves the assessment performance by classes, it includes all the assignees who took the assessments.
     * @param classes
     * @param assessments
     * @param bands               - performance bands to apply to the items
     */
    AnalyticsService.prototype.getAssessmentPerformanceByClass = function (classes, assessments, bands, assessmentTemplates) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, assessmentTemplateIds, assessmentPerformanceData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        assessmentTemplateIds = assessmentTemplates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.assessmentPerformanceClient.findByContextAndAssignee(ids, [], (0, uniq_1.default)(assessmentTemplateIds), this.getDefaultHeaders())];
                    case 1:
                        assessmentPerformanceData = _a.sent();
                        return [2 /*return*/, this.buildAssessmentPerformance(assessments, assessmentPerformanceData, bands)];
                }
            });
        });
    };
    /**
     * Retrieves the most recent date were a standard was assessed
     * @param assessments: Assessment[]
     * @param standard: string
     */
    AnalyticsService.prototype.getMostRecentAssessedStandardDate = function (assessments, standard) {
        var validAssessments = assessments.filter(function (assessment) {
            return assessment.assessmentTemplate.standards.includes(standard);
        });
        if ((0, isEmpty_1.default)(validAssessments)) {
            return null;
        }
        var mostRecentAssessedStandardDate = validAssessments[0].endDate;
        validAssessments.forEach(function (_a) {
            var endDate = _a.endDate;
            if (providers_1.dateProvider.isAfter(endDate, mostRecentAssessedStandardDate)) {
                mostRecentAssessedStandardDate = endDate;
            }
        });
        return mostRecentAssessedStandardDate;
    };
    AnalyticsService.prototype.buildAssessmentPerformance = function (assessments, assessmentPerformanceDtos, bands) {
        var _this = this;
        var assessmentsPerformance = [];
        assessments.forEach(function (assessment) {
            var performance = assessmentPerformanceDtos.find(function (_a) {
                var assessmentId = _a.assessmentId;
                return assessmentId === assessment.id;
            });
            if (performance) {
                var maxScore = performance.maxScore, score = performance.score, totalAssignees = performance.totalAssignees;
                var percentage = _this.calculatePercentage(score, maxScore);
                assessmentsPerformance.push(new models_1.AssessmentPerformance({
                    assessment: assessment,
                    maxScore: maxScore,
                    score: score,
                    percentage: percentage,
                    totalAssignees: totalAssignees,
                    performanceBand: (0, helpers_1.findPerformanceBand)(percentage, bands),
                }));
            }
        });
        return assessmentsPerformance;
    };
    /**
     * Merge item standards into an Item
     * @param {ItemStandard[]} itemStandards - Item standards array
     * @param {Item} item                    - Item
     */
    AnalyticsService.prototype.mergeStandardsByHierarchy = function (itemStandards, item) {
        var data = [];
        var itemStandardData = itemStandards.filter(function (_a) {
            var externalItemId = _a.externalItemId;
            return externalItemId === item.externalId;
        });
        if (!(0, isEmpty_1.default)(itemStandardData)) {
            itemStandardData.forEach(function (itemStandard) {
                data.push({
                    hierarchyLevel: itemStandard.hierarchyLevel,
                    standardGlobalIds: itemStandard.standardGlobalIds,
                });
            });
        }
        item.standardsByHierarchy = data;
        return item;
    };
    /**
     * Getting the data for latest item performance of student by class and template id
     * @param contextId => This represent class id
     * @param assessmentTemplateId => This represents current assessment template id
     * @param itemExternalId => This represents current question id
     * @returns
     */
    AnalyticsService.prototype.getAssessmentStudentsItemPerformance = function (contextId, assessmentTemplateId, itemExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            var latestItemPerformanceData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.itemPerformanceClient.findByContextAndItemAndTemplate(contextId, itemExternalId, assessmentTemplateId, this.getDefaultHeaders())];
                    case 1:
                        latestItemPerformanceData = _a.sent();
                        return [2 /*return*/, latestItemPerformanceData.map(function (itemPerformance) {
                                return _this.studentPerformanceSerializer.serialize(itemPerformance);
                            })];
                }
            });
        });
    };
    /**
     * Getting the data for the items skipped by students
     * @param contextId => This represent class id
     * @param assessmentTemplateId => This represents current assessment template id
     * @returns {Promise<SkippedItemResponse>}
     */
    AnalyticsService.prototype.getStudentsSkippedItemsPercentage = function (contextId, assessmentTemplateId) {
        return this.itemPerformanceClient.findSkippedByContextAndTemplate(assessmentTemplateId, contextId, this.getDefaultHeaders());
    };
    /**
     * Getting the data for the highest and lowest-performing assessment from all assessments assigned to a class
     * @param contextId: string => this will represent the class id
     */
    AnalyticsService.prototype.getLowestAndHighestPerformingAssessment = function (contextId) {
        return this.assessmentPerformanceClient.findHighAndLowPerformingByContext(contextId, this.getDefaultHeaders());
    };
    return AnalyticsService;
}(base_service_1.BaseService));
exports.AnalyticsService = AnalyticsService;
